export default "* Panfløjte\n* Rør\n* Blæseinstrument";